export const BRANCHASSOCIATIONLIST_SEARCH = 'BRANCHASSOCIATIONLIST_SEARCH';
export const BRANCHASSOCIATIONLIST_PAGE = 'BRANCHASSOCIATIONLIST_PAGE';
